module.exports = __webpack_public_path__ + "img/pt.3103c0f1.svg";